import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders, HttpRequest} from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { NEVER, Observable, of } from 'rxjs';
import { InternalService } from './internal.service';

@Injectable()
export class ApiService {
  developingMode = false;
  api = 'https://app.alobodo.com';
  detectedLang: string | any;

  // Services
  constructor(private http: HttpClient,
    private internalService: InternalService,
    private router: Router,) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, langId) {
    localStorage.setItem('dir', language);
    localStorage.setItem('lang', langId);
  }

  
  countryLangMap: { [key: string]: string } = {
    'US': 'en', // English
    'GB': 'en',
    'FR': 'fr', // French
    'DE': 'de', // German
    'ES': 'es', // Spanish
    'IR': 'fa', // Farsi (Persian)
    'CN': 'zh', // Chinese
    'JP': 'ja'  // Japanese
  };

  async detectLanguage(): Promise<string> {
    const location = await this.getUserLocation();
    console.log('|||||',location);
    
    if (!location) {
      return null; 
    }

    const country = await this.getCountryFromCoordinates(location.latitude, location.longitude);
    return this.countryLangMap[country] || null; 

  }

  async getUserLocation(): Promise<{ latitude: number; longitude: number } | null> {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        console.error('Geolocation is not supported by this browser.');
        return resolve(null);
      }
  
      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude
          });
        },
        (error) => {
          console.error('Geolocation error:', error);
          return resolve(null);
          // switch (error.code) {
          //   case error.PERMISSION_DENIED:
          //     console.error('User denied location access.');
          //     break;
          //   case error.POSITION_UNAVAILABLE:
          //     console.error('Location unavailable.');
          //     break;
          //   case error.TIMEOUT:
          //     console.error('Request timed out.');
          //     break;
          //   default:
          //     console.error('Unknown error.');
          // }
          // resolve(null);
        },
        { enableHighAccuracy: true }
      );
    });
  }

  async getCountryFromCoordinates(lat: number, lng: number): Promise<string | null> {
    const url = `https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}&accept-language=en`;
  
    try {
      const response = await this.http.get<any>(url).toPromise();
      return response.address.country_code.toUpperCase(); // Returns country code (e.g., "US", "FR", "IR")
    } catch (error) {
      console.error('Error getting country:', error);
      return null;
    }
  }
  
  
  
  

  getMyIP(){
    return this.http.get('https://getip.medis.land/getip').pipe(
      catchError(error => {
        if (error.status === 401) {
          // window.location.href = ' ';
          this.router.navigate(['']);
          return NEVER;      // <-- never emit after the redirect
        }
        // this.showMessage(' ', null);
        return of([]);
      })
    );
  }

  getLocationFromAPI(body){
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.post('https://mac.medis.land/api/ip/IpToLocation', body, {
      headers,
    });
  }

  GetProvinces(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/location/GetProvinces/' + id, {
      headers,
    });
  }

  getCities(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/location/GetCities/' + id, {
      headers,
    });
  }

  getCategories() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/app/GetCategories/' + 1, {headers});
  }

  techPreRegister(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.post(this.api + '/api/app/TechPreRegister/', body, {
      headers,
    });
  }

  getTags(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/app/GetTags/' + id + '/' + 1, {
      headers,
    });
  }

  getSiteCategories() {

    const lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'1';
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(
      this.api + '/api/site/GetCategories/' + lang,
      // this.api + '/api/site/GetCategories/' + localStorage.getItem('lang')?localStorage.getItem('lang'):'1',
      {headers}
    );
  }

  getProfile(id) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: localStorage.getItem('lang'),
    });
    return this.http.get(
      'https://app.alobodo.com/Account/' + id , {headers}
    );
  }

  getAllCategories() {

    const lang = localStorage.getItem('lang')?localStorage.getItem('lang'):'1';
    
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(
      this.api + '/api/site/GetAllCategories/' + lang,
      {headers}
    );
  }

  getImage(image) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/image/GetImage/' + image, {
      headers,
    });
  }

  getSkillImage(image) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get('https://app.alobodo.com' + '/api/image/GetImage/' + image, {
      headers,
    });
  }

  getCategory(categoryid) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/site/GetCategory/' + localStorage.getItem('lang') + '/' + categoryid, {
      headers,
    });
  }
  search(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.post(this.api + '/api/site/Search/' + localStorage.getItem('lang') ,body, {
      headers,
    });
  }
  getAboutUs(lang) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.get(this.api + '/api/app/GetAboutUs/' + lang , {
      headers,
    });
  }
  sendFeedback(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.post(this.api + '/api/site/SendFeedback/'  ,body, {
      headers,
    });
  }
  getPopularCategories() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: localStorage.getItem('lang')?localStorage.getItem('lang'):'1'
    });
    return this.http.get(this.api + '/api/Site/GetPopularCategories/' , {
      headers,
    });
  }
  getDeleteAccountQuestions() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: localStorage.getItem('lang')
    });
    return this.http.get(this.api + '/api/account/GetDeleteAccountQuestions' , {
      headers,
    });
  }
  sendDeleteAccountReq(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
    });
    return this.http.post(this.api + '/api/account/RequestDeleteAccountWebsite'  ,body, {
      headers,
    });
  }
}
